import { DayPicker } from 'react-day-picker'
import * as React from 'react'

export type CalendarProps = React.ComponentProps<typeof DayPicker>

export default function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  // noinspection JSUnusedGlobalSymbols
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={`p-3 ${className}`}
      classNames={{
        months: 'flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0',
        month_caption: 'flex justify-center items-center',
        caption_label: 'hidden',
        dropdown:
          'rounded-md text-sm font-medium border-0 leading-6 focus:ring-0 hover:bg-slate-100 mb-2',
        nav: 'space-x-1 flex items-center',
        button_previous: 'hidden',
        button_next: 'hidden',
        month_grid: 'w-full border-collapse space-y-1',
        weekdays: 'flex space-x-1',
        weekday: 'text-muted-foreground w-9 font-semibold text-sm text-center',
        week: 'flex w-full mt-2 space-x-1',
        day: 'text-center p-0 relative text-sm hover:bg-slate-100 rounded-full',
        day_button: 'h-9 w-9 p-0 font-normal',
        selected:
          '!hover:bg-blue-600 !bg-blue-600 !rounded-full text-white !font-semibold focus:bg-blue-600 focus:text-primary-foreground',
        today: 'text-blue-600 !font-semibold',
        disabled: 'text-red-400 opacity-50',
        outside: 'text-muted-foreground opacity-50',
        range_middle:
          'aria-selected:bg-accent aria-selected:text-accent-foreground',
        hidden: 'invisible',
        ...classNames,
      }}
      {...props}
    />
  )
}
